module.exports = __webpack_public_path__ + "static/cellphoneHome-557fa0e581f42f2467be442304ba583a.png";